/* ===========================================================================
   BIBLIOTECA DE ROMs LOCAIS (IndexedDB)
   ---------------------------------------------------------------------------
   Guarda o File de cada ROM aberta por drag & drop / seletor — "Continuar"
   e os chips de recentes passam a funcionar para elas entre visitas
   (ids com prefixo "local:"). O banco NÃO entra no arquivo de backup:
   ROMs são grandes demais para o .json (o padrão BACKUP_DB_PATTERN não
   casa com o nome de propósito).
   ======================================================================== */






/** Formata bytes para exibição (painel de saves / biblioteca local). */
function formatBytes(bytes) {
  if (!Number.isFinite(bytes) || bytes <= 0) return '—';
  const units = ['B', 'KB', 'MB', 'GB'];
  let value = bytes;
  let unit = 0;
  while (value >= 1024 && unit < units.length - 1) {
    value /= 1024;
    unit += 1;
  }
  return `${value.toFixed(value >= 10 || unit === 0 ? 0 : 1)} ${units[unit]}`;
}

// @generated-exports
export { formatBytes };
// @generated-exports
